export default __webpack_public_path__ + "images/NL.fd06a1a.png";